"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityModuleWithCompletionRateSchema = exports.activityModuleSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.activityModuleSchema = zod_1.default.object({
    _id: zod_1.default.string(),
    name: zod_1.default.string(),
    slug: zod_1.default.string(),
    backgroundUrl: zod_1.default.string(),
    unitId: zod_1.default.string(),
    public: zod_1.default.boolean(),
    new: zod_1.default.boolean(),
    soon: zod_1.default.boolean(),
});
exports.activityModuleWithCompletionRateSchema = exports.activityModuleSchema.merge(zod_1.default.object({
    activityCount: zod_1.default.number(),
    completionRate: zod_1.default.number(),
}));
//# sourceMappingURL=activityModule.js.map